import { T } from "../utils/translations";

export default {
  'User email already exists': T.userEmailAlreadyExists,
  'User is not yet active': T.userNotYetActive,
  'Bad Credentials': T.badCredentials,
}
